import { encodeUrlFromRouter, encodeUrlToRouter } from "@/routerUrlEncoding";
import axios from "axios";

//const stageDef = {
//  Reconnections: { name: 'Reconnections', type: 5 },
//  Disconnections: { name: 'Disconnections', type: 2 }
//};

export default {
  name: "DmSelectWalks",
  components: {
    CircleLoadingIndicator:
      require("@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue")
        .default,
    BackButton: require("@/components/backButton/backButton.vue").default,
  },
  props: {},
  data: function () {
    return {
      backUrl: "",
      batchNo: null,
      stage: null,
      billGroup: null,
      walks: [],
      isLoading: false,
      selectedItemId: -1,
      displayType: { text: null, color: null },
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.getSelectedItem();
  },
  methods: {
    init() {
      this.billGroup = encodeUrlFromRouter(this.$route.params.billGroup);
      this.stage = encodeUrlFromRouter(this.$route.params.stage);
      this.batchNo = encodeUrlFromRouter(this.$route.params.batch);

      this.displayType = {
        text:
          this.stage == 5
            ? `(${this.$t("disconnections.Reconnections")})`
            : this.stage == 2
            ? `(${this.$t("disconnections.Disconnections")})`
            : null,

        color:
          this.stage == 5
            ? "color-blue-text"
            : this.stage == 2
            ? "color-red-text"
            : null,
      };

      this.backUrl = `debtManagementSelectBatch`;
      this.getWalks();
    },
    getSelectedItem() {
      let selection = this.$store.getters.getDmSelectionSettings;
      if (selection && selection.book_walkIdSelected)
        this.selectedItemId = selection.book_walkIdSelected;
    },
    selectedItem(item) {
      return this.selectedItemId == `${item.walkNo}_${item.bookNo}`
        ? "background-color-gray_wached"
        : "";
    },
    getWalks() {
      this.isLoading = true;

      axios
        .get(
          `/DmConnection/GetEmployeeWalks?batchNo=${this.batchNo}&stage=${this.stage}&billGroup=${this.billGroup}`
        )
        .then((response) => {
          if (response.status == 200) {
            response.data.sort((a, b) =>
              a.walkNo > b.walkNo
                ? 1
                : a.walkNo === b.walkNo
                ? a.bookNo > b.bookNo
                  ? 1
                  : -1
                : -1
            );
            this.walks = response.data;
          } else this.$oldAlertMsg(this.$t("disconnections.WalksError"));
        })
        .catch((e) => {
          this.$oldAlertMsg(this.$t("disconnections.WalksError"));
        })
        .finally(() => {
          this.isLoading = false;

          if (this.selectedItemId > 0)
            setTimeout(() => {
              this.$scrollToElement(this.selectedItemId);
            }, 1000);
        });
    },
    selectItem(item) {
      if (!item) return;

      const bookId = encodeUrlToRouter(item.bookNo);
      const walkId = encodeUrlToRouter(item.walkNo);

      this.$store.dispatch("setDmSelectionSettings", {
        book_walkIdSelected: `${item.walkNo}_${item.bookNo}`,
      });
      let route = `/debtManagementSelectRecord/${encodeUrlToRouter(
        this.billGroup
      )}/${encodeUrlToRouter(this.stage)}/${encodeUrlToRouter(
        this.batchNo
      )}/${encodeUrlToRouter(bookId)}/${encodeUrlToRouter(walkId)}`;
      this.$router.push(route);
    },
  },
};
